module.exports = __webpack_public_path__ + "static/media/tramites-02.6d77f62e.png";